<template>
    <div class="verifyPhoneCode flex-column align-center">
        <p class="verifyPhoneCode-title">输入短信验证码</p>
        <div class="verifyPhoneCode-input-wrap">
            <van-password-input :value="code" :gutter="10" :focused="showKeyboard" @focus="showKeyboard = true" :mask="false" :length="4" />
        </div>
        <!-- 数字键盘 -->
        <van-number-keyboard v-model="code" :show="showKeyboard" @blur="showKeyboard = false" />
        <div class="verifyPhoneCode-btn">
            <van-button :disabled="disabled" class="comfirm-btn" @click="nextStep">下一步</van-button>
        </div>
        <p class="verifyPhoneCode-reGet" @click="reGetCode">
            <span v-if="second > 0">{{ second }}S</span> <span :style="{ color: second > 0 ? '#B8B8B8' : '#009AF3' }">重新获取</span>
        </p>
    </div>
</template>

<script>
import { checkSmsCode } from "@/api/index";
export default {
    name: "verifyPhoneCode",
    data() {
        return {
            code: "",
            showKeyboard: true,
            second: 60,
            timer: null,
        };
    },
    computed: {
        disabled() {
            return this.code.length != 4;
        },
    },
    mounted() {
        this.secondCountDown();
    },
    methods: {
        secondCountDown() {
            this.timer = setInterval(() => {
                if (this.second > 0) {
                    this.second -= 1;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        nextStep() {
            checkSmsCode({
                captchaCode: this.code,
                phoneNo: this.$route.params.phoneNo,
            }).then((res) => {
                if (res.code == 200) {
                    this.$router.push({
                        name: "verifyIdCard",
                    });
                }
            });
        },
        reGetCode() {
            if (this.second <= 0) {
                console.log("重新获取");
            } else {
                console.log("稍后再获取");
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.comfirm-btn {
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.verifyPhoneCode {
    min-height: 100vh;
    background-color: #fff;
    padding-top: 190px;
    .verifyPhoneCode-title {
        font-size: 32px;
        font-weight: 500;
        color: #666666;
    }
    .verifyPhoneCode-input-wrap {
        width: 100vw;
        padding: 48px 119px;
    }
    .verifyPhoneCode-btn {
        padding: 0 24px;
        margin-top: 110px;
    }
    .verifyPhoneCode-reGet {
        color: @main-color;
        font-size: 30px;
        margin-top: 40px;
    }
}
</style>
<style lang="less">
.van-password-input__item {
    border: 1px solid #eee;
    border-radius: 8px;
    // height: 80px;
    // width: 74px;
}
</style>
